// src/scripts/exclusive.js

// Inicializar o Video.js uma vez para o player exclusivo
const exclusivePlayer = videojs('exclusive-video-player');

// Função para tocar o canal exclusivo
function playExclusiveChannel(streamUrl) {
    $('#exclusive-video-source').attr('src', streamUrl);
    exclusivePlayer.src({ src: streamUrl, type: 'application/x-mpegURL' });

    var playPromise = exclusivePlayer.play();

    if (playPromise !== undefined) {
        playPromise.then(_ => {
            // Automatic playback started!
        }).catch(error => {
            // Auto-play was prevented
            // Show paused UI.
            console.error("Playback prevented: ", error);
        });
    }

    $('#live-section').show();
}

// Função para parar o vídeo e esconder a seção
function closeLiveSection() {
    exclusivePlayer.pause();
    $('#exclusive-video-source').attr('src', '');
    $('#live-section').hide();
}

// Evento de clique para os botões de assistir
$('#show-live-section1').on('click', function() {
    const streamUrl = $(this).data('stream-url');
    playExclusiveChannel(streamUrl);
});

$('#show-live-section2').on('click', function() {
    const streamUrl = $(this).data('stream-url');
    playExclusiveChannel(streamUrl);
});

$('#show-live-section3').on('click', function() {
    const streamUrl = $(this).data('stream-url');
    playExclusiveChannel(streamUrl);
});

$('#show-live-section4').on('click', function() {
    const streamUrl = $(this).data('stream-url');
    playExclusiveChannel(streamUrl);
});

$('#show-live-section5').on('click', function() {
    const streamUrl = $(this).data('stream-url');
    playExclusiveChannel(streamUrl);
});

$('#show-live-section6').on('click', function() {
    const streamUrl = $(this).data('stream-url');
    playExclusiveChannel(streamUrl);
});

$('#show-live-section7').on('click', function() {
    const streamUrl = $(this).data('stream-url');
    playExclusiveChannel(streamUrl);
});

// Evento de clique para o botão de fechar
$('#close-live-section').on('click', closeLiveSection);
